import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { useNavigate, Link } from 'react-router-dom';

export default function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        const { error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });

        if (error) {
            setError(error.message);
        } else {
            navigate('/platforma');
        }
    };

    return (
        <div className="min-h-screen bg-bg-dark flex items-center justify-center p-4">
            <div className="bg-bg-card p-8 rounded-2xl border border-white/10 w-full max-w-md">
                <h2 className="text-2xl font-bold text-white mb-6 text-center">Zaloguj się</h2>

                {error && (
                    <div id="login-error" role="alert" className="bg-red-500/10 border border-red-500/20 text-red-500 p-3 rounded-lg mb-6">
                        {error}
                    </div>
                )}

                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-400 mb-1">Email</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            aria-invalid={!!error}
                            aria-describedby={error ? "login-error" : undefined}
                            className="w-full bg-black/50 border border-white/10 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-primary/50 focus-visible:ring-2 focus-visible:ring-primary/50"
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-400 mb-1">Hasło</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            aria-invalid={!!error}
                            aria-describedby={error ? "login-error" : undefined}
                            className="w-full bg-black/50 border border-white/10 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-primary/50 focus-visible:ring-2 focus-visible:ring-primary/50"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-primary hover:bg-primary-light text-white font-medium py-2.5 rounded-lg transition-colors mt-2"
                    >
                        Zaloguj się
                    </button>
                </form>

                <p className="text-center mt-6 text-gray-400 text-sm">
                    Nie masz konta? <Link to="/dolacz" className="text-primary hover:text-primary-light transition-colors">Zarejestruj się</Link>
                </p>
            </div>
        </div>
    );
}
